import { render, staticRenderFns } from "./LostItemList.vue?vue&type=template&id=4e25b2f0"
import script from "./LostItemList.vue?vue&type=script&lang=js"
export * from "./LostItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports